import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export type ZendeskAuthResponse = {
  jwt: string
}

export const getZendeskAuthToken = () =>
  fetchApi<ZendeskAuthResponse>({
    auth: true,
    method: 'POST',
    url: getApiUrl('nabu-gateway/zendesk/jwt-chat-auth')
  })
